
$(function () {

    var ww = $(window).width();
    console.log(ww);
    if(ww <= 768){
        console.log('这是wap端~');
        window['adaptive'].desinWidth = 750;//设计稿宽度
        window['adaptive'].baseFont = 28;//默认字体大小
        window['adaptive'].maxWidth = 750;//最大宽度
        window['adaptive'].init();
    }else {
        console.log('这是pc端~');
        window['adaptive'].desinWidth = 1340;//设计稿宽度
        window['adaptive'].baseFont = 14;//默认字体大小
        window['adaptive'].maxWidth = 1340;//最大宽度
        window['adaptive'].init();
    }
});


//
// $(window).resize(function () {          //当浏览器大小变化时
//   console.log('变成pc端啦~');
//   window['adaptive'].desinWidth = 1340;//设计稿宽度
//   window['adaptive'].baseFont = 14;//默认字体大小
//   window['adaptive'].maxWidth = 1340;//最大宽度
//   window['adaptive'].init();
// });




// WEBPACK FOOTER //
// ./src/assets/js/common.js